import React from "react";
import Slider from "react-slick";
import Institute1 from "../../../assets/Images/logos/institute-1-min.webp";
// import Institute2 from "../../../assets/Images/logos/institute-2-min.webp";
import Institute3 from "../../../assets/Images/logos/institute-3-min.webp";
import Institute4 from "../../../assets/Images/logos/institute-4-min.webp";
import Institute5 from "../../../assets/Images/logos/institute-5-min.webp";
import Institute6 from "../../../assets/Images/logos/institute-6-min.webp";
import Institute7 from "../../../assets/Images/logos/institute-7-min.webp";
import Institute8 from "../../../assets/Images/logos/institute-8-min.webp";
import Institute9 from "../../../assets/Images/logos/institute-9-min.webp";
import Institute11 from "../../../assets/Images/logos/institute-11-min.webp";
import Institute12 from "../../../assets/Images/logos/institute-12-min.webp";
import Institute14 from "../../../assets/Images/logos/institute-14-min.webp";
import Institute15 from "../../../assets/Images/logos/institute-15-min.webp";
import Institute16 from "../../../assets/Images/logos/institute-16-min.webp";
import Institute17 from "../../../assets/Images/logos/institute-17-min.webp";
import Institute18 from "../../../assets/Images/logos/institute-18-min.webp";
import Institute19 from "../../../assets/Images/logos/institute-19-min.webp";
import Institute20 from "../../../assets/Images/logos/institute-20-min.webp";
import Institute21 from "../../../assets/Images/logos/institute-21-min.webp";
import Institute22 from "../../../assets/Images/logos/institute-22-min.webp";
import Institute23 from "../../../assets/Images/logos/institute-23-min.webp";
import Institute24 from "../../../assets/Images/logos/institute-24-min.webp";
import Institute25 from "../../../assets/Images/logos/institute-25-min.webp";
import Institute26 from "../../../assets/Images/logos/institute-26-min.webp";
import Institute27 from "../../../assets/Images/logos/institute-27-min.webp";
import Institute28 from "../../../assets/Images/logos/institute-28-min.webp";
import Institute29 from "../../../assets/Images/logos/institute-29-min.webp";
import { useMediaQuery } from "react-responsive";

const InstitutesList = () => {
  const isScreen800 = useMediaQuery({ query: "(max-width: 800px)" });
  const isScreen600 = useMediaQuery({ query: "(max-width: 600px)" });
  //const isScreen400 = useMediaQuery({ query: "(max-width: 400px)" });

  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: isScreen600 ? 3 : isScreen800 ? 5 : 5,
    slidesToScroll: 1,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 0,
    cssEase: "linear",
  };

  return (
    <Slider {...settings}>
      <div className="institutes__content_card">
        <img src={Institute1} alt="" className="" />
        {/* <div className="institutes__content_card__text">
          <p className="institutes__content_card__text__name">AV Smart Study</p>
          <p className="institutes__content_card__text__location">Ghaziabad</p>
        </div> */}
      </div>

      {/* <div className="institutes__content_card">
        <img src={Institute2} alt="" className="" />
         <div className="institutes__content_card__text">
          <p className="institutes__content_card__text__name">Adhyatmn</p>
          <p className="institutes__content_card__text__location">Kota</p>
        </div> 
      </div> */}
      <div className="institutes__content_card">
        <img src={Institute3} alt="" className="" />
      </div>

      <div className="institutes__content_card">
        <img src={Institute4} alt="" className="" />
      </div>

      <div className="institutes__content_card">
        <img src={Institute5} alt="" className="" />
      </div>

      <div className="institutes__content_card">
        <img src={Institute6} alt="" className="" />
      </div>

      <div className="institutes__content_card">
        <img src={Institute7} alt="" className="" />
      </div>

      <div className="institutes__content_card">
        <img src={Institute8} alt="" className="" />
      </div>

      <div className="institutes__content_card">
        <img src={Institute9} alt="" className="" />
      </div>

      <div className="institutes__content_card">
        <img src={Institute11} alt="" className="" />
      </div>

      <div className="institutes__content_card">
        <img src={Institute12} alt="" className="" />
      </div>

      <div className="institutes__content_card">
        <img src={Institute14} alt="" className="" />
      </div>

      <div className="institutes__content_card">
        <img src={Institute15} alt="" className="" />
      </div>

      <div className="institutes__content_card">
        <img src={Institute16} alt="" className="" />
      </div>

      <div className="institutes__content_card">
        <img src={Institute17} alt="" className="" />
      </div>

      <div className="institutes__content_card">
        <img src={Institute18} alt="" className="" />
      </div>

      <div className="institutes__content_card">
        <img src={Institute19} alt="" className="" />
      </div>

      <div className="institutes__content_card">
        <img src={Institute20} alt="" className="" />
        {/* <div className="institutes__content_card__text">
          <p className="institutes__content_card__text__name">
            TRANSITION Classes Gwalior
          </p>
          <p className="institutes__content_card__text__location">Gwalior</p>
        </div> */}
      </div>

      <div className="institutes__content_card">
        <img src={Institute21} alt="" className="" />
      </div>

      <div className="institutes__content_card">
        <img src={Institute22} alt="" className="" />
      </div>

      <div className="institutes__content_card">
        <img src={Institute23} alt="" className="" />
      </div>

      <div className="institutes__content_card">
        <img src={Institute24} alt="" className="" />
      </div>

      <div className="institutes__content_card">
        <img src={Institute25} alt="" className="" />
      </div>

      <div className="institutes__content_card">
        <img src={Institute26} alt="" className="" />
      </div>

      <div className="institutes__content_card">
        <img src={Institute27} alt="" className="" />
      </div>

      <div className="institutes__content_card">
        <img src={Institute28} alt="" className="" />
      </div>

      <div className="institutes__content_card">
        <img src={Institute29} alt="" className="" />
      </div>
    </Slider>
  );
};

export default InstitutesList;
